import { ReportAPI } from 'api'
import { mapResponse } from 'utils/api'

import { IQueryConfig, IQueryOptions } from '../query/types'

import { getQuery } from './queries'

export const fetchSimpleReport = (
  queryConfig: IQueryConfig,
  options: IQueryOptions
): Promise<any> => {
  const { query, parseFunction } = getQuery(queryConfig, options)
  return ReportAPI.post('/conversation-summary/report/simple', query)
    .then(mapResponse)
    .then((response) => parseFunction(response, queryConfig))
}

export const fetchReportCSV = (
  queryConfig: IQueryConfig,
  options: IQueryOptions
): Promise<string> => {
  const { query } = getQuery(queryConfig, options)
  return ReportAPI.post(`/conversation-summary/report/csv`, query, {
    responseType: 'text',
  }).then(mapResponse)
}
